/**
 * Loads a video player based on an mpx or parsely feed url
 */

import React from 'react';
import ReactDOM from 'react-dom';
import FsPlaylistService from '../shared/services/FsPlaylistService';
import VideoPlayer from '../videoPlayer/VideoPlayer';
import { getPostId } from '../shared/utils';

const limit = 25; 

class FeedVideoPlayer extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            videos: null
        }
    }

    componentDidMount(){
        const postId = getPostId();

        let feedUrl = this.props.feedUrl
        if(feedUrl.indexOf('feed.theplatform.com') !==  -1 ) {
            //fetch videos using mpx feed
            new FsPlaylistService().getMpxPlaylist( feedUrl, limit, postId ).then( videos => {
                this.setState(() => ({
                    videos: videos
                }))
            });
        }
        else if(feedUrl.indexOf('api.parsely.com') !==  -1 ) {
            //fech videos using parsely feed
            new FsPlaylistService().getParselyContentByFeed(feedUrl, postId).then( videos => {
                this.setState(() => ({
                    videos: videos
                }))
            });
        }

    }

    render(){
        const videos = this.state.videos;
        return ( 
            videos && 
            <VideoPlayer playlist={videos} autoplay={this.props.autoplay} playlistTitle={this.props.playlistTitle} showUnavailableMsg={this.props.showUnavailableMsg}></VideoPlayer>
        )

    }
}

let feedVideoPlayerTag = document.getElementsByTagName('FeedVideoPlayer');
feedVideoPlayerTag = feedVideoPlayerTag.length > 0 && feedVideoPlayerTag[0];

if(feedVideoPlayerTag) {
    let mpxFeed = feedVideoPlayerTag.getAttribute('feed-url');
    let autoplay = feedVideoPlayerTag.getAttribute('autoplay');
    let playlistTitle = feedVideoPlayerTag.getAttribute('playlist-title');
    let categoryLogoSrc = feedVideoPlayerTag.getAttribute('category-logo');
    let showUnavailableMsg = feedVideoPlayerTag.getAttribute('showUnavailableMsg');

    ReactDOM.render(<FeedVideoPlayer feedUrl={mpxFeed} autoplay={autoplay} playlistTitle={playlistTitle} showUnavailableMsg={showUnavailableMsg}
        categoryLogoSrc={categoryLogoSrc}></FeedVideoPlayer>, feedVideoPlayerTag);

}